import { render, staticRenderFns } from "./MallShopOrder.vue?vue&type=template&id=4e7f92b3&scoped=true"
import script from "./MallShopOrder.vue?vue&type=script&lang=js"
export * from "./MallShopOrder.vue?vue&type=script&lang=js"
import style0 from "./MallShopOrder.vue?vue&type=style&index=0&id=4e7f92b3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e7f92b3",
  null
  
)

export default component.exports